// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"vR","promotionalTile":"vS","promotionalTileThumb":"vT","promotionalTileHeader":"vU","promotionalTileCaption":"vV"};